import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { FieldSet, Table } from '@sigeco/tools';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { detallePedido, setOrder, onUpdateColumn } from '../../../store/movilidad/reportepedidos/actions';
import { closeMessageBox, openMessageBox } from '../../../store/main/actions';
import { useState } from 'react';
import { sort_by } from '../../../helpers/commons';
import Modal from '@material-ui/core/Modal';
import { formatoPeru } from '../../../helpers/commons';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flex: '1 1 auto',
        flexDirection: 'column',
    },
    tableWrap: {
        flex: '1 1 auto',
    },
    modal: {
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        borderRadius: '15px',
    },
    bot: {
        marginLeft: '10px',
        marginTop: '5px',
    },
    resul: {
        fontSize: '10px !important',
        background: 'white',
        textAlign: 'Left !important',
    },
    resuld: {
        fontSize: '10px !important',
        textAlign: 'Right !important',
        background: 'white',
    },
    // Tabla de info del pedido (cabecera y envío)
    infoTable: {
        width: '100%',
        borderCollapse: 'collapse',
        tableLayout: 'fixed',
        '& td': {
            fontSize: '10px',
            padding: '4px',
        },
        '@media (max-width: 560px)': {
            '& tr': {
                display: 'block',
                marginBottom: '4px',
                border: 'none',    // ← sin bordes en el tr
            },
            '& td': {
                display: 'block',
                width: '100% !important',
                border: 'none',    // ← sin bordes en el td
                boxSizing: 'border-box',
                textAlign: 'left !important',
            },
            '& td[data-label="true"]': {
                backgroundColor: '#BFD9FF',
                fontWeight: 'bold',
                paddingBottom: '2px',
            },
        },
    },
    infoShipTable: {
        width: '100%',
        borderCollapse: 'collapse',
        tableLayout: 'fixed',
        '& td': {
            fontSize: '10px',
            padding: '4px',
        },
        '@media (max-width: 560px)': {
            '& tr': {
                display: 'block',
                marginBottom: '4px',
                border: 'none',
            },
            '& td': {
                display: 'block',
                width: '100% !important',
                border: 'none',
                boxSizing: 'border-box',
            },
            '& td[data-label="true"]': {
                backgroundColor: '#BFD9FF',
                fontWeight: 'bold',
                paddingBottom: '2px',
            },
        },
    },
    // Tabla de productos: scroll horizontal
    docsTableWrap: {
        overflowX: 'auto',
        width: '100%',
        marginBottom: '20px',
        '& table': {
            borderCollapse: 'collapse',
            minWidth: '400px',
            width: '100%',
        },
    },
    infoValor: {
        backgroundColor: '#FFFFFF',
        color: '#1A2B4A',
        fontSize: '11px',
        fontWeight: 600,
        padding: '5px 8px',
        border: '1px solid #C8D6EE',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        verticalAlign: 'middle',
    },
    // ── Badge de estado ───────────────────────────────────────────────────────
    estadoPendiente: {
        display: 'inline-block',
        backgroundColor: '#E8EFFF',
        color: '#0033CC',
        fontSize: '10px',
        fontWeight: 700,
        padding: '1px 8px',
        borderRadius: '10px',
        border: '1px solid #99AAEE',
        whiteSpace: 'nowrap',
    },
    estadoAprobado: {
        display: 'inline-block',
        backgroundColor: '#E5F6EC',
        color: '#1A7F3C',
        fontSize: '10px',
        fontWeight: 700,
        padding: '1px 8px',
        borderRadius: '10px',
        border: '1px solid #90D4A8',
        whiteSpace: 'nowrap',
    },
    estadoRechazado: {
        display: 'inline-block',
        backgroundColor: '#FDECEA',
        color: '#C0392B',
        fontSize: '10px',
        fontWeight: 700,
        padding: '1px 8px',
        borderRadius: '10px',
        border: '1px solid #F0A89F',
        whiteSpace: 'nowrap',
    },
    estadoRevisado: {
        display: 'inline-block',
        backgroundColor: '#FEF8E7',
        color: '#9A6D00',
        fontSize: '10px',
        fontWeight: 700,
        padding: '1px 8px',
        borderRadius: '10px',
        border: '1px solid #E8CC80',
        whiteSpace: 'nowrap',
    },
}));

function ReportePedidosList() {
    const classes = useStyles();
    const [showJsonModal, setShowJsonModal] = React.useState(false);
    const columns = useSelector((state) => state.reportepedidos.table.columns);
    const loading = useSelector((state) => state.reportepedidos.loading);
    const order = useSelector((state) => state.reportepedidos.table.order);
    const orderBy = useSelector((state) => state.reportepedidos.table.orderBy);
    const store = useSelector((state) => state.reportepedidos.store);
    const dispatch = useDispatch();
    const [, setShowModal] = useState(false);
    const [show, setShow] = useState(false);
    const HandleClose = () => setShow(false);
    const HandleShow = () => setShow(true);

    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && order === 'asc';
        dispatch(setOrder(isAsc ? 'desc' : 'asc', property));
        let homes = store.data;
        homes.sort(sort_by(property, isAsc, homes[0][property]));
    };

    const handleDoubleClick = (item) => {
        let items = [];
        items.push(item);
        dispatch(detallePedido(items[0]));
        setShowModal(HandleShow);
    };

    const handleResizeColumn = (column) => {
        dispatch(onUpdateColumn(column));
    };

    const truncateText = (text, maxLength = 150) => {
        if (!text || text.length <= maxLength) return text;
        return text.substring(0, maxLength) + '...';
    };

    const formatJson = (jsonString) => {
        try {
            if (!jsonString) return 'No hay datos';
            const parsed = JSON.parse(jsonString);
            return JSON.stringify(parsed, null, 2);
        } catch (error) {
            return jsonString;
        }
    };

    const HandleOpenJson = () => setShowJsonModal(true);
    const HandleCloseJson = () => setShowJsonModal(false);

    const ModalContent = () => {
        const pedido = useSelector((state) => state.reportepedidos.store.pedido);
        const datad = useSelector((state) => state.reportepedidos.store.detalle);

        let total = 0;
        return (
            <div>
                <Modal aria-labelledby="simple-modal-title" aria-describedby="simple-modal-description" open={show} onClose={HandleClose}>
                    <div
                        className={classes.modal}
                        style={{
                            maxHeight: '90vh',
                            maxWidth: 900,
                            width: '90%',
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            padding: '16px 24px 24px 24px',
                        }}
                    >
                        <h2 style={{ textAlign: 'center', fontSize: '18px', marginTop: 0 }}>Detalle de Pedido</h2>

                        {/* ── Tabla de información del pedido ── */}
                        <div style={{ marginBottom: '15px' }}>
                            <table className={classes.infoTable}>
                                <tbody>
                                    <tr>
                                        <td data-label="true" style={{ width: '14%', backgroundColor: '#BFD9FF', fontWeight: 'bold' }}>CODIGO PEDIDO:</td>
                                        <td style={{ width: '16%' }}>
                                            <b>{pedido.codigo}</b>
                                        </td>
                                        <td data-label="true" style={{ width: '8%', backgroundColor: '#BFD9FF', fontWeight: 'bold' }}>NIT:</td>
                                        <td style={{ width: '14%' }}>
                                            <b>{pedido.nitCliente}</b>
                                        </td>
                                        <td data-label="true" style={{ width: '10%', backgroundColor: '#BFD9FF', fontWeight: 'bold' }}>ESTADO:</td>
                                        <td className={classes.infoValor} style={{width: '14%', textAlign: 'center'}}>
                                            <BadgeEstado estado={pedido.estado} classes={classes} />
                                        </td>
                                        <td data-label="true" style={{ width: '10%', backgroundColor: '#BFD9FF', fontWeight: 'bold' }}>FECHA:</td>
                                        <td style={{ width: '14%' }}>{pedido.fechaRegistro}</td>
                                    </tr>
                                    <tr>
                                        <td data-label="true" style={{ backgroundColor: '#BFD9FF', fontWeight: 'bold' }}>CLIENTE:</td>
                                        <td colSpan="3">{pedido.dCliente}</td>
                                        <td data-label="true" style={{ backgroundColor: '#BFD9FF', fontWeight: 'bold' }}>VENDEDOR:</td>
                                        <td colSpan="3">{pedido.dVendedor}</td>
                                    </tr>
                                    <tr>
                                        <td data-label="true" style={{ backgroundColor: '#BFD9FF', fontWeight: 'bold' }}>OBSERVACIÓN:</td>
                                        <td colSpan="7">
                                            <b>{pedido.observacion}</b>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        {/* ── Tabla de productos (scroll horizontal) ── */}
                        <div className={classes.docsTableWrap}>
                            <div style={{ display: 'none' }}>
                                {!loading && datad.map((ite) => (total = total + ite.cantidad * ite.precioFinal))}
                            </div>
                            <table className="aprobacion" id="tableMod">
                                <thead>
                                    <tr>
                                        <th style={{ backgroundColor: '#e3f2fd', padding: '8px', border: '1px solid #BFD2E9', fontSize: '10px', whiteSpace: 'nowrap', minWidth: '120px' }}>
                                            Código
                                        </th>
                                        <th style={{ backgroundColor: '#e3f2fd', padding: '8px', border: '1px solid #BFD2E9', fontSize: '10px', whiteSpace: 'nowrap', minWidth: '200px' }}>
                                            Descripción
                                        </th>
                                        <th style={{ backgroundColor: '#e3f2fd', padding: '8px', border: '1px solid #BFD2E9', fontSize: '10px', whiteSpace: 'nowrap', minWidth: '80px' }}>
                                            Cantidad
                                        </th>
                                        <th style={{ backgroundColor: '#e3f2fd', padding: '8px', border: '1px solid #BFD2E9', fontSize: '10px', whiteSpace: 'nowrap', minWidth: '110px' }}>
                                            Precio
                                        </th>
                                        <th style={{ backgroundColor: '#e3f2fd', padding: '8px', border: '1px solid #BFD2E9', fontSize: '10px', whiteSpace: 'nowrap', minWidth: '110px' }}>
                                            Estado
                                        </th>
                                    </tr>
                                </thead>
                                <tbody style={{ border: '1px solid #BFD2E9' }}>
                                    {!loading &&
                                        datad.map((item, index) => (
                                            <tr style={{ backgroundColor: 'Gainsboro' }} key={index}>
                                                <td className={classes.resul} style={{ padding: '6px', border: '1px solid #BFD2E9', whiteSpace: 'nowrap' }}>
                                                    {item.codigoProducto}
                                                </td>
                                                <td className={classes.resul} style={{ padding: '6px', border: '1px solid #BFD2E9' }}>
                                                    {item.dProducto}{item.bonificacionId > 0 ? ` - ${item.bonificacionId}` : ''}
                                                </td>
                                                <td className={classes.resuld} style={{ padding: '6px', border: '1px solid #BFD2E9', whiteSpace: 'nowrap' }}>
                                                    {item.cantidad}
                                                </td>
                                                <td className={classes.resuld} style={{ padding: '6px', border: '1px solid #BFD2E9', whiteSpace: 'nowrap' }}>
                                                    {formatoPeru('en-US', 'USD', item.precioFinal)}
                                                </td>
                                                <td className={classes.infoValor}>
                                                    <BadgeEstado estado={item.estado} classes={classes} />
                                                </td>
                                            </tr>
                                        ))}
                                    {datad.length > 0 && !loading && (
                                        <tr key={1000} style={{ backgroundColor: 'white' }}>
                                            <td className={classes.resuld} colSpan="4" style={{ padding: '8px', textAlign: 'right', border: '1px solid #BFD2E9' }}>
                                                <b style={{ fontSize: '12px' }}>Total: {formatoPeru('en-US', 'USD', total)}</b>
                                            </td>
                                        </tr>
                                    )}
                                    {datad.length === 0 && !loading && (
                                        <tr key={1}>
                                            <td className={classes.resul} colSpan="4" style={{ padding: '6px' }}>
                                                No existe Registro
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                                {loading && (
                                    <tbody>
                                        <tr>
                                            <td colSpan="4" style={{ textAlign: 'center', padding: '20px' }}>
                                                <img alt="log" src="https://app.iess.gob.ec/iess-fondo-reserva-afiliado-web/javax.faces.resource/images/load.gif.jsf;jsessionid=8949b76cfea43d283add3bd3dd2d?ln=sentinel-layout" width="40" height="40" />
                                            </td>
                                        </tr>
                                    </tbody>
                                )}
                            </table>
                        </div>

                        {/* ── Detalle de envío ── */}
                        <div style={{ marginBottom: '20px' }}>
                            <h2 style={{ fontSize: '18px', marginBottom: '10px' }}>Detalle de envío</h2>
                            <table className={classes.infoTable}>
                                <tbody>
                                    <tr>
                                        <td data-label="true" style={{ width: '18%', backgroundColor: '#BFD9FF', fontWeight: 'bold' }}>CODIGO ORIGEN:</td>
                                        <td style={{ width: '20%' }}>
                                            <b>{pedido.codigoOrigen}</b>
                                        </td>
                                        <td data-label="true" style={{ width: '12%', backgroundColor: '#BFD9FF', fontWeight: 'bold' }}>ESTADO:</td>
                                        <td style={{ width: '18%' }}>
                                            <b>{pedido.estadoEnvio === 1 ? 'ENVIADO' : 'NO ENVIADO'}</b>
                                        </td>
                                        <td data-label="true" style={{ width: '15%', backgroundColor: '#BFD9FF', fontWeight: 'bold' }}>FECHA:</td>
                                        <td style={{ width: '17%' }}>{pedido.fechaEnvio}</td>
                                    </tr>
                                    <tr>
                                        <td data-label="true" style={{ backgroundColor: '#BFD9FF', fontWeight: 'bold' }}>RESPUESTA DE ENVIO:</td>
                                        <td colSpan="5" style={{ wordBreak: 'break-word' }}>
                                            <b>{pedido.respuesta}</b>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td data-label="true" style={{ backgroundColor: '#BFD9FF', fontWeight: 'bold', verticalAlign: 'top' }}>JSON ENVIADO:</td>
                                        <td colSpan="5">
                                            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                                                <span style={{ flex: 1, wordBreak: 'break-all' }}>
                                                    <b>{truncateText(pedido.jsonEnviado, 150) || 'N/A'}</b>
                                                </span>
                                                {pedido.jsonEnviado && pedido.jsonEnviado.length > 150 && (
                                                    <Button
                                                        variant="outlined"
                                                        color="primary"
                                                        size="small"
                                                        style={{ fontSize: '10px', padding: '2px 8px', textTransform: 'none', minWidth: '70px' }}
                                                        onClick={HandleOpenJson}
                                                    >
                                                        Ver más
                                                    </Button>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            {/* Modal del JSON */}
                            <Modal open={showJsonModal} onClose={HandleCloseJson} aria-labelledby="json-modal-title">
                                <div
                                    style={{
                                        top: '50%',
                                        left: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        position: 'absolute',
                                        maxHeight: '85vh',
                                        maxWidth: 700,
                                        width: '90%',
                                        backgroundColor: 'white',
                                        boxShadow: '0px 11px 15px -7px rgba(0,0,0,0.2)',
                                        borderRadius: '15px',
                                        padding: '24px',
                                        overflowY: 'auto',
                                    }}
                                >
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                                        <h2 style={{ margin: 0, fontSize: '18px' }}>JSON Enviado</h2>
                                    </div>
                                    <div
                                        style={{
                                            backgroundColor: '#f5f5f5',
                                            padding: '15px',
                                            borderRadius: '8px',
                                            fontSize: '12px',
                                            fontFamily: 'monospace',
                                            whiteSpace: 'pre-wrap',
                                            wordBreak: 'break-word',
                                            overflowX: 'auto',
                                            marginTop: '10px',
                                            border: '1px solid #ddd',
                                        }}
                                    >
                                        {formatJson(pedido.jsonEnviado)}
                                    </div>
                                    <div style={{ marginTop: '20px', textAlign: 'right' }}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() => {
                                                navigator.clipboard.writeText(formatJson(pedido.jsonEnviado));
                                                HandleCloseJson();
                                                HandleClose();
                                                dispatch(
                                                    openMessageBox({
                                                        button: 'ok',
                                                        icon: 'info',
                                                        message: 'JSON copiado al portapapeles',
                                                        callback: () => dispatch(closeMessageBox()),
                                                    }),
                                                );
                                            }}
                                            style={{ marginRight: '10px' }}
                                        >
                                            Copiar
                                        </Button>
                                        <Button variant="outlined" onClick={HandleCloseJson}>
                                            Cerrar
                                        </Button>
                                    </div>
                                </div>
                            </Modal>
                        </div>

                        {/* ── Botón cerrar sticky ── */}
                        <div
                            style={{
                                position: 'sticky',
                                bottom: 0,
                                backgroundColor: 'white',
                                paddingTop: '15px',
                                paddingBottom: '10px',
                                textAlign: 'right',
                                marginLeft: '-24px',
                                marginRight: '-24px',
                                paddingRight: '24px',
                                borderTop: '1px solid #e0e0e0',
                            }}
                        >
                            <Button variant="contained" color="primary" onClick={HandleClose} className={classes.bot}>
                                Cerrar
                            </Button>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    };

    function BadgeEstado({ estado, classes }) {
        const mapa = {
            P: { cls: classes.estadoPendiente, txt: 'PENDIENTE' },
            A: { cls: classes.estadoAprobado,  txt: 'APROBADO'  },
            R: { cls: classes.estadoRechazado, txt: 'RECHAZADO' },
        };
        const cfg = mapa[estado] ?? { cls: classes.estadoRevisado, txt: 'REVISADO' };
        return <span className={cfg.cls}>{cfg.txt}</span>;
    }


    return (
        <FieldSet className={classes.root} iconCls="fas fa-th-list" title="Resultados">
            <div style={{ display: 'none' }}>
                <ReactHTMLTableToExcel id="table-xls-button-rpt-pedidos" className="" table="table-to-xls" filename="Rpt_pedidos" sheet="Pedidos" buttonText="" />
            </div>

            <div className={classes.tableWrap}>
                <Table
                    columns={columns}
                    count={store.total}
                    loading={loading}
                    onRowClick={(items) => { }}
                    onRowDoubleClick={(items) => handleDoubleClick(items)}
                    onSort={(datakey) => handleRequestSort(datakey)}
                    onUpdateColumn={handleResizeColumn}
                    rowCount={store.data.length}
                    rowGetter={(index) => store.data[index]}
                    selected={store.selected}
                    sortBy={orderBy}
                    sortDirection={order}
                    noRowsRenderer={() => <div>hola</div>}
                />
            </div>
            <div className="App">{show ? <ModalContent /> : null}</div>
        </FieldSet>
    );
}

export default ReportePedidosList;